
import { Link } from "react-router-dom";
import { useState } from "react"
import { MdNavigateBefore } from "react-icons/md";

import { MdOutlineNavigateNext } from "react-icons/md";


export default function RealTimeData({ sellingHistory }) {
  let mints = Object.keys(sellingHistory).reverse()




  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 5 // Number of items per page

  // Calculate the index of the first and last item for the current page
  const lastIndex = currentPage * itemsPerPage
  const firstIndex = lastIndex - itemsPerPage
  const currentTokens = mints.slice(firstIndex, lastIndex)

  // Calculate total number of pages
  const totalPages = Math.ceil(mints.length / itemsPerPage)

  // Handlers for pagination controls
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  const goToFirstPage = () => {
    setCurrentPage(1)
  }

  const goToLastPage = () => {
    setCurrentPage(totalPages)
  }



const RenderStatus = ()=>{

}



  return (

    <div className={` max-w-[100%] space-y-3 overflow-x-scroll `}>
      <h1 className="px-1 text-neutral-400 border-b border-yellow-500/10 rounded ">Trading history :</h1>

      <table className="  rounded-lg    overflow-hidden  w-full h-max ">
        <thead className="bg-neutral-900">

          <tr className="text-yellow-600 text-left font-semibold capitalize text-xs rounded-lg ">
            <th className="p-3 text-xs">Name</th>
            <th className="p-3 text-xs">Buy MC</th>
            <th className="p-3 text-xs">Sell MC</th>
            <th className="p-3 text-xs">Transaction</th>
            <th className="p-3 text-xs">Result</th>
          </tr>
        </thead>

        <tbody className=" !overflow-y-scroll">


          {
            currentTokens?.map((mint, i) => {
              return (
                <tr key={'table' + i} className={`text-neutral-300  border-b border-neutral-800  hover:bg-neutral-400/10 transition-all h-14 ${Number(sellingHistory[mint]?.buyMc) <= sellingHistory[mint]?.sellMc ? "bg-green-500/20" : "bg-red-500/20"} `} >
                  <td className="p-3 text-xs text-yellow-500 hover:text-pink-500 truncate w-10">
                    <Link target="_blank" to={`https://pump.fun/coin/${mint}`} >
                      <p className="truncate w-20 ">

                        {sellingHistory[mint]?.name || 'noname'}
                      </p>
                    </Link>
                  </td>
                  <td className="p-3 text-xs ">{Number(sellingHistory[mint]?.buyMc).toFixed(2) || "no marketcap data"}</td>
                  <td className="p-3 text-xs ">{Number(sellingHistory[mint]?.sellMc).toFixed(2) || "no marketcap data"}</td>
                  <td className="p-1 text-xs  "> <p className="p-1 text-xs truncate  border border-neutral-800 w-20 rounded-lg px-5 bg-neutral-800 ">{sellingHistory[mint]?.serverTransaction || 'no transaction data '}</p>   </td>
                  <td className="p-1 text-xs  ">

                    {sellingHistory[mint]?.isWinning == "win" &&
                      <button className="py-1 px-2 w-full bg-green-500 text-white rounded">Take Profit</button>}
                    {sellingHistory[mint]?.isWinning == "trailing" &&
                      <button className="py-1 px-2 w-full bg-yellow-500 text-black rounded">Trailing Stop</button>}

                    {sellingHistory[mint]?.isWinning === "sell" && <button className="py-1 px-2 w-full bg-purple-500 text-white rounded">manual</button>
                    }

                    {sellingHistory[mint]?.isWinning === "loss" && <button className="py-1 px-2 w-full bg-red-500 text-white rounded">stop out</button>}


                  </td>
                </tr>
              )
            })
          }
        </tbody >
      </table>

      {mints.length > itemsPerPage &&
        <div className="flex justify-start gap-5 items-center mt-4">

          <button disabled={currentPage === 1} className="bg-yellow-500 rounded-full p-1 items-center justify-center cursor-pointer hover:scale-110" onClick={goToPrevPage} >
            <MdNavigateBefore className="text-2xl" />
          </button>
          <button disabled={currentPage === totalPages} className="bg-yellow-500 rounded-full p-1 items-center justify-center cursor-pointer hover:scale-110" onClick={goToNextPage}>
            <MdOutlineNavigateNext className="text-2xl" />
          </button>

          <span className="p-2 text-white">Page {currentPage} of {totalPages}</span>

        </div>}

    </div>


  )


}